<script setup>
import { useForm } from '@inertiajs/vue3';
import { inject } from 'vue';

// Components
import Card from '@/Components/Card.vue';
import Pagination from '@/Components/Pagination.vue';
import ResourceCategoriesFilter from '@/Components/ResourceCategoriesFilter.vue';

const props = defineProps({
    query: Object,
    title: String,
    news: Object,
    newsCategories: Object,
    amount_news: String,
});

const route = inject('route');

const form = useForm({
    page: props.news?.page ?? 1,
    categories: props.query?.categories ?? [],
});

const submit = (resetPage = true) => {
    form.page = resetPage ? 1 : form.page;
    form.get(route('public.news.index'), {
        preserveState: true,
    });
};

const setPage = (e) => {
    form.page = e;
    submit(false);
};
</script>

<template>
    <div class="bg-gray-lighter" v-if="news.data">
        <div class="container py-12 md:py-16">
            <h2 class="" v-html="title" v-if="title"></h2>

            <ResourceCategoriesFilter :query="query" v-model="form.categories" :categories="newsCategories"
                :route="route('public.news.index')" @update:modelValue="submit"
                v-if="newsCategories && amount_news == '16'" />

            <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
                <article v-for="project in news.data" :key="i" class="flex flex-col bg-white rounded-xl '">
                    <Card :key="project.id" :type="project"
                        :href="route('public.news.show', { slug: project.page_slug })" />
                </article>
            </div>

            <Pagination v-if="news !== 'undefined' && news.links.length >= 16" :links="news.links" @setPage="setPage"
                :pageData="news" />
        </div>
    </div>
</template>
